import { Loading, RotatingCircle } from './styled';
export const GrayLoading = () => {
  return (
    <Loading>
      <RotatingCircle />
      <p>Carregando dados...</p>
    </Loading>
  );
};
